module.exports = __webpack_public_path__ + "img/en.3d5c30bf.png";